export default "__VITE_ASSET__BYSLWSMW__"